<template>
    <div
        class="common-collapsible"
        v-bind:class="{ _expanded: isOpen, _bordered: bordered }"
    >
        <div
            class="common-collapsible__header"
            v-on:click="isOpen = !isOpen"
        >
            <div class="common-collapsible__header-title">
                {{ title }}
            </div>
            <div class="common-collapsible__header-right">
                <div class="common-collapsible__header-attention" v-if="attention">
                    <span class="common-collapsible__header-attention-text">{{ attention }}</span>
                    <span class="common-collapsible__header-attention-icon">
                        <icon name="warning" width="16" height="16" />
                    </span>
                </div>
                <div class="common-collapsible__header-toggle">
                    <icon name="triangle" width="16" height="16" color="#000" />
                </div>
            </div>
        </div>
        <template v-if="isOpen">
            <div class="common-collapsible__content">
                <slot />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'common-collapsible',
    props: {
        title: String,
        attention: String,
        bordered: {
            type: Boolean,
            default: false,
        },
        initOpen: {
            type: Boolean,
            default: false,
        },
        startCollapsedOnMobile: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isOpen: false,
    }),
    mounted() {
        if (!this.startCollapsedOnMobile) {
            this.isOpen = !!this.initOpen;
        } else if (window.innerWidth >= 768) {
            this.isOpen = !!this.initOpen;
        }
    },
};
</script>

<style scoped lang="less">
@import '~theme';
.common-collapsible {
    width: 100%;

    &._bordered {
        border: 1px solid @color-gray-light;
        border-radius: @border-radius-md;
    }
    &._bordered & {
        &__header {
            padding: 16px;
        }
        &__content {
            margin: 0 16px 16px 16px;
        }
    }
    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        &-title {
            .typography-heading();
        }
        &-right {
            display: flex;
            align-items: center;
            gap: 24px;
        }
        &-attention {
            &-text {
                .typography-caption();

                display: none;

                text-transform: uppercase;
                font-weight: bold;
                color: @color-primary;
            }
            @media @media-md-up {
                &-text {
                    display: block;
                }
            }
            &-icon {
                display: none;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                color: @color-primary;
            }
            @media @media-sm-down {
                &-icon {
                    display: flex;
                }
            }
        }
        &-toggle {
            transform: rotate(-180deg);
            cursor: pointer;
            ._expanded & {
                transform: rotate(0);
            }
        }
    }
    &__content {
        .typography-body();

        margin-top: 16px;
    }
}
</style>
